import { transformCurrencyAmountDto } from './currency-amount';
export const transformVasGalleryOrderItemDto = dto => ({
  itemId: dto.item_id,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable)
});
export const transformVasGalleryOrderDto = dto => ({
  id: dto.id,
  durationDays: dto.duration_days,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  items: dto.items.map(transformVasGalleryOrderItemDto),
  termsNote: dto.terms_note
});